import { render, staticRenderFns } from "./ConfirmDish.vue?vue&type=template&id=e6eeb028&scoped=true&"
import script from "./ConfirmDish.vue?vue&type=script&lang=js&"
export * from "./ConfirmDish.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDish.vue?vue&type=style&index=0&id=e6eeb028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6eeb028",
  null
  
)

export default component.exports